import {WikiSearchAuthor, WikiSearchDocumentType, WikiSearchOrderType} from '../models/wiki';

export function getInitialSearchState(authors?: WikiSearchAuthor[]) {
    return {
        status: 'initial' as const,
        params: {
            authors,
            text: '',
            page: 1,
            order: WikiSearchOrderType.Relevancy,
            showObsolete: false,
            documentType: WikiSearchDocumentType.ALL,
        },
    };
}
